import React, { useState } from 'react';
import '../styles/HowToPlay.css';
import { GoBook } from 'react-icons/go';
import datamode from '../assets/modal-instructions/datamode.png';
import gridsize from '../assets/modal-instructions/gridsize.png';
import insertagent from '../assets/modal-instructions/insert-agent.png';
import insertgoal from '../assets/modal-instructions/insert-goal.png';
import insertobstacle from '../assets/modal-instructions/insert-obstacle.png';
import start from '../assets/modal-instructions/start.png';
import settings from '../assets/modal-instructions/settings.png';
import refresh from '../assets/modal-instructions/refresh.png';
import thememode from '../assets/modal-instructions/thememode.png';
import clearAgents from '../assets/modal-instructions/clearAgents.png';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA

const HowToPlay = () => {
    const maxModalPages = 9;
    const [showHowToPlay, setShowHowToPlay] = useState(false);
    const [modalPageNumber, setModalPageNumber] = useState(1);

    function handleClick() {
        setShowHowToPlay(true);
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'How to Play Modal is Clicked'
        });
    }

    function handleClose() {
        setShowHowToPlay(false);
        setModalPageNumber(1);
    }


    function goPrevPage() {
        if (modalPageNumber > 1) {
            setModalPageNumber(modalPageNumber - 1)
        }
    }

    function goNextPage() {
        if (modalPageNumber < maxModalPages) {
            setModalPageNumber(modalPageNumber + 1)
        }
    }

    function handleClickModal(event) {
        event.stopPropagation(); // prevent click events from propagating to parent elements
    }

    return (
        <div className="howtoplay-div" >
            <button className="btn-primary howtoplay-btn" onClick={handleClick}>
                <span className="howtoplay-text">How to Play</span>
                <GoBook size={20} className="howtoplay-icon" />
            </button>

            {showHowToPlay && (
                <div className="modal" onClick={handleClickModal}>
                    <div className="modal-content">
                        <span className="close" onClick={handleClose}>
                            &times;
                        </span>

                        <h2>How to Play</h2>

                        {modalPageNumber == 1 &&
                            <div className='modal-page-div'>
                                <img src={gridsize} alt="" className="modal-page-image" />
                                <p>Increase or Decrease the grid size according to the size you want to play.</p>
                            </div>
                        }
                        {modalPageNumber == 2 &&
                            <div className='modal-page-div'>
                                <img src={datamode} alt="" className="modal-page-image" />
                                <p>Select the object you want to insert into the grid.</p>
                            </div>
                        }
                        {modalPageNumber == 3 &&
                            <div className='modal-page-div'>
                                <img src={insertobstacle} alt="" className="modal-page-image" />
                                <p>Insert Obstacle into the grid by clicking desired location on the grid.</p>
                            </div>
                        }
                        {modalPageNumber == 4 &&
                            <div className='modal-page-div'>
                                <img src={insertagent} alt="" className="modal-page-image" />
                                <p>Change to "Agent" and insert Agent by clicking desired location on the grid.</p>
                            </div>
                        }
                        {modalPageNumber == 5 &&
                            <div className='modal-page-div'>
                                <img src={insertgoal} alt="" className="modal-page-image" />
                                <p>Change to "Goal". Then, click on an Agent, followed by its desired Goal location on the grid.</p>
                            </div>
                        }
                        {modalPageNumber == 6 &&
                            <div className='modal-page-div'>
                                <img src={start} alt="" className="modal-page-image" />
                                <p>Click the Play button to observe how the Agents move to its Goal with minimum steps.</p>
                            </div>
                        }
                        {modalPageNumber == 7 &&
                            <div className='modal-page-div'>
                                <img src={refresh} alt="" className="modal-page-image" />
                                <p>Click the Refresh button to restart the game.</p>
                            </div>
                        }
                        {modalPageNumber == 8 &&
                            <div className='modal-page-div'>
                                <img src={clearAgents} alt="" className="modal-page-image" />
                                <p>Click the Clear Agent Button to remove all agents.</p>
                            </div>
                        }
                        {modalPageNumber == 9 &&
                            <div className='modal-page-div'>
                                <img src={thememode} alt="" className="modal-page-image" />
                                <p>Click the Bulb button to switch between Neon Mode and Light Mode.</p>
                            </div>
                        }




                        <div className="page-navigator">

                            <span className="arrow-right" onClick={goPrevPage}>
                                &lt;
                            </span>

                            <span className="page-navigator-text">
                                {modalPageNumber} / {maxModalPages}
                            </span>

                            <span className="arrow-right" onClick={goNextPage}>
                                &gt;
                            </span>



                        </div>

                    </div>
                </div>
            )
            }
        </div >
    );
};

export default HowToPlay;
